import { ReceiveMessageBody, WebSocketMessageTypes } from '@/websocket/types'
import { WebSocketMessageMode } from '@/websocket/constants'
import WebSocketReceiver from '@/websocket/receivers/receiver'

export const enum WebSocketCallMessageTypes {
  REQUEST = 'call_request',
  DENIED = 'call_denied',
  CANCELED = 'call_canceled',
  ACCEPTED = 'call_accepted'
}

export const enum VideoCallDeniedReasonCode {
  DENIED = 1000
}

export default class CallWebSocketReceiver extends WebSocketReceiver<
  WebSocketMessageMode.CALL
> {
  handleMessage(
    messageBody: ReceiveMessageBody<
      WebSocketMessageMode.CALL,
      WebSocketMessageTypes<WebSocketMessageMode.CALL>
    >
  ) {
    if (!messageBody) {
      return
    }

    switch (messageBody.type) {
      case WebSocketCallMessageTypes.DENIED:
        this.events.emit(WebSocketCallMessageTypes.DENIED, messageBody)
        break
      case WebSocketCallMessageTypes.CANCELED:
        this.events.emit(WebSocketCallMessageTypes.CANCELED, messageBody)
        break
      case WebSocketCallMessageTypes.REQUEST:
        this.events.emit(WebSocketCallMessageTypes.REQUEST, messageBody)
        break
      default:
        break
    }
  }
}
